import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { RefundRequestComponent } from 'src/app/Product/refund-request/refund-request.component';
import { RefundService } from 'src/app/_services/refund.service';
import { CancelRefundComponent } from '../cancelRefund/cancel-refund/cancel-refund.component';
import { AuthService } from 'src/app/_services/auth.service';
import { PageEvent } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/_services/common.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatSort, Sort } from '@angular/material/sort';
import { AlertService } from 'src/app/_alert';

@Component({
  selector: 'app-refund',
  templateUrl: './refund.component.html',
  styleUrls: ['./refund.component.css']
})

export class RefundComponent implements OnInit {
  refundData: any = [];
  isLoading: boolean = false;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };
  constructor(public dialog: MatDialog,
    public refundService: RefundService,
    public authService: AuthService,
    private alertService: AlertService,
    public commonService: CommonService,
    private _liveAnnouncer: LiveAnnouncer
  ) { }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  subscription: Subscription;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnInit(): void {
    this.getRefund();
    this.subscription = this.commonService.refreshGrid$.subscribe((refresh) => {
      if (refresh) {
        this.getRefund();
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  pageIndex: number = 0;
  pageSize: number = 5;
  customerId = this.authService.getRegistredUserDetails().customerId;
  AFSTransactionId: string;
  totalCount: number;

  displayedColumns: string[] = ['srNo', 'refundReqOn', 'transRefNo', 'refundAmount', 'refundStatus', 'cancel'];
  dataSource = new MatTableDataSource(this.refundData);

  //get refund detail by id
  getRefundDetailsById(refundRequestId: any) {
    this.refundService.getRefundDetailsById(refundRequestId).subscribe((response: any) => {
      console.log(response);
      const dialogRef = this.dialog.open(RefundRequestComponent, {
        width: '700px',
        height: 'auto',
        disableClose: true,
        data: {
          lenderName: response.lenderName,
          vendorId: response.vendorId,
          borrower: response.partyName,
          loanId: response.loanNumber,
          property: response.property,
          authPnRef: response.authRef,
          refundPnRef: response.pnrefCode,
          refundAmt: response.refundAmount,
          refundRequestId: response.refundRequestId,
          custTrackingNo: response.custTrackingNo
        }
      });
    })
  }

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getRefund();
  }

  //get refund
  getRefund() {
    this.isLoading = true;
    const data = {
      pageIndex: this.pageIndex + 1,
      pageSize: this.pageSize,
      customerId: this.customerId,
      AFSTransactionId: this.AFSTransactionId = ''
    }
    this.refundService.getRefund(data).subscribe((response: any) => {
      console.log(response);
      this.refundData = response.refundRequests;
      // this.dataSource = this.refundData;
      this.dataSource = new MatTableDataSource(this.refundData);
      this.totalCount = response.totalCount;
      this.isLoading = false;
    }, (err) => {
      console.log(err);
      this.alertService.error(err.error.errors.Messages[0], this.options);
      this.isLoading = false;
    })
  }

  //cancel refund
  cancelRefund(refundRequestId: any) {
    const dialogRef = this.dialog.open(CancelRefundComponent, {
      maxWidth: 'auto',
      width: '550px',
      height: 'auto',
      disableClose: true,
      data: { refundRequestId: refundRequestId }
    });
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
